// POST
export const ENDPOINTS_POST = {
}

// PUT
export const ENDPOINTS_PUT = {
}

// GET
export const ENDPOINTS_GET = {
	GET_AUTOCOMPLETE_ADDRESS: '/autocomplete',
	GET_METADATA: '/metadata/'
}

// DELETE
export const ENDPOINTS_DELETE = {
}